module.exports = __webpack_public_path__ + "img/registration_at_blaupause.887f16c1.webp";